module.exports = __webpack_public_path__ + "static/media/bolepix-confirmation.d16ce4c4.svg";